/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListTemplates = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-list-templates_svg__st0{fill:currentcolor}'}</style>
    <path className="ico-list-templates_svg__st0" d="M2 2v20h6v-2H4V4h16v12h2V2zm16 16h4v2h-4z" />
    <path
      className="ico-list-templates_svg__st0"
      d="M13 16c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-14H6v8h8V6zm-2 6H8V8h4v4zm4 0h2v2h-2zm0-3h2v2h-2zm0-3h2v2h-2z"
    />
  </Icon>
);
export { SvgListTemplates as ListTemplates };
